<!--
 * @Author: maogangfeng
 * @Date: 2020-03-21 14:43:32
 * @Desc: 预警推送弹窗
 -->
<template>
  <el-dialog
    :visible.sync="isVisible"
    title="推送预警"
    size="large"
    :area="areaSize"
    no-scrollbar
    custom-class="warning-push-dialog"
  >
    <div class="warning-container">
      <div class="warning-image-wrap">
        <div class="image-draw-area">
          <div class="draw-tool-bar">
            <div
              class="draw-pen-rect"
              :class="{ 'pen-active': drawType === 'rect' }"
              @click="handleDrawType('rect')"
            ></div>
            <div
              class="draw-pen-circle"
              :class="{ 'pen-active': drawType === 'circle' }"
              @click="handleDrawType('circle')"
            ></div>
          </div>
          <div v-if="isShowPicker" class="color-picker">
            <div
              v-for="picker in colorPicker"
              :key="picker"
              :style="`background:${picker}`"
              :class="{ 'color-active': picker === drawColor }"
              @click="changleDrawColor(picker)"
            ></div>
          </div>
          <canvas ref="dealCanvas" width="356" height="300"></canvas>
        </div>
      </div>
      <div class="warning-info-wrap">
        <el-alert title="请先绘制区域并指定预警位置。" simple type="info" show-icon />
        <el-input
          v-model="comment"
          type="textarea"
          :rows="4"
          resize
          :count="256"
          placeholder="请输入处置预警意见"
        ></el-input>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleWarningPush">
        确 定
      </el-button>
      <el-button @click="isVisible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import DrawPen from './DrawPen'
import http from '@/api/enterpriseVideoInspection'
export default {
  name: 'WarningPushDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    captureImage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      areaSize: [620, 416],
      uploadImage: '',
      isVisible: false,
      comment: '',
      isShowPicker: false,
      drawPen: null,
      drawType: 'rect',
      drawColor: '#ff2501',
      colorPicker: ['#ff2501', '#01b4ff', '#61ed01', '#ffeb01', '#676767', '#ffffff']
    }
  },
  computed: {},
  watch: {
    dialogVisible(val) {
      this.init()
      this.isVisible = val
    },

    isVisible(val) {
      this.$emit('update:dialogVisible', val)
    },

    captureImage(url) {
      const image = new Image()
      image.width = 356
      image.height = 300
      image.src = 'data:image/png;base64,' + url
      this.$nextTick(() => {
        this.generateDrawPen(image)
      })
    }
  },
  methods: {
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-23 18:58:19
     * @Desc: 重置推送弹窗状态
     */
    init() {
      this.comment = ''
      this.uploadImage = ''
      // this.drawPen && this.drawPen.clearCanvas()
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-26 10:31:54
     * @Desc: 生成绘图
     */
    generateDrawPen(image) {
      if (this.drawPen) {
        this.drawPen.clearCanvas()
        this.drawPen.resetFeature()
        this.drawPen.setBackgroundImage(image)
        this.drawPen.refreshImage()
      } else {
        this.drawPen = new DrawPen(this.$refs['dealCanvas'], image)
        this.drawPen.setColor(this.drawColor)
        this.drawPen.setDrawWay(this.drawType)
        this.drawPen.init()
      }
    },
    async uploadImageByManual() {
      const base64Data = this.$refs['dealCanvas'].toDataURL('image/png')
      const blob = this.dataURItoBlob(base64Data)
      const params = new FormData()
      params.append('file', blob, 'cavas.png')
      const { data } = await http.uploadCapture(params)
      return data
    },
    dataURItoBlob(base64Data) {
      const bytes = window.atob(base64Data.split(',')[1]) // 去掉url的头，并转换为byte

      // 处理异常,将ascii码小于0的转换为大于0
      const ab = new ArrayBuffer(bytes.length)
      const ia = new Uint8Array(ab)
      for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i)
      }

      return new Blob([ab], {
        type: 'image/png'
      })
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-23 18:37:18
     * @Desc: 预警推送确定
     */
    async handleWarningPush() {
      const imageUrl = await this.uploadImageByManual()
      this.$emit('alarmPush', { url: imageUrl, comment: this.comment })
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-26 18:58:29
     * @Desc: 修改绘图类型
     */
    handleDrawType(drawType) {
      this.drawType = drawType
      this.isShowPicker = true
      this.drawPen.setDrawWay(drawType)
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-26 19:04:10
     * @Desc: 修改绘图颜色
     */
    changleDrawColor(drawColor) {
      this.drawColor = drawColor
      this.isShowPicker = false
      this.drawPen.setColor(drawColor)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .warning-push-dialog {
  margin-left: 15% !important;
}
.warning-container {
  display: flex;
  height: 300px;
}
.warning-image-wrap {
  flex: none;
  width: 356px;
  height: 300px;
  img {
    width: 100%;
    height: 100%;
  }
}
.warning-info-wrap {
  width: 100%;
  padding-left: 16px;
  .el-textarea {
    margin-top: 8px;
  }
}
.image-draw-area {
  position: relative;
  .draw-tool-bar {
    position: absolute;
    top: 0;
    width: 100%;
    height: 35px;
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
  }
  .draw-pen-rect,
  .draw-pen-circle {
    width: 20px;
    height: 20px;
    margin: 0 10px 0 20px;
    border: 1px solid #fff;
    cursor: pointer;
  }
  .pen-active {
    border: 1px solid #08f236;
  }
  .color-active {
    box-shadow: 0px 0px 7px 4px #fff;
  }
  .draw-pen-circle {
    border-radius: 50%;
  }
}
.color-picker {
  position: absolute;
  display: none;
  top: 40px;
  width: 160px;
  height: 30px;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: space-around;
  align-items: center;
  & > div {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}
</style>
